<style lang="scss">
.print_template_dialog {
  .el-dialog {
    .el-dialog__body {
      max-height: 100%;
      padding: 0 20px;
    }
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/print/template/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('dayinmobanmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dayinyewuleixing')">
            <yi_dictionary_select :max="1" :type="'PRINT_TEMPLATE_BUSINESS_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_base_label_management_print_template_management_create')" @click="yt.showEditDialog('xinzeng', null, '96%')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!-- 操作插槽 -->
      <template #guizexiangqing="scope">
        <div style="display:flex">
          <p v-for="(detail, i) in scope.row.labelRuleDetailsVOList"><span v-if="i != 0">+</span>{{ $t(store.state.dictJsonAll['BAR_CODE_RULE_TYPE'][detail.ruleType]) }}</p>
        </div>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_label_management_print_template_management_update')" @click="yt.showEditDialog('bianji', scope.row, '96%')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_label_management_print_template_management_create')" @click="yt.showEditDialog('fuzhi', scope.row, '96%')">
              {{ $t('fuzhi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_base_label_management_print_template_management_delete')" @click="yt.remove(scope.row, '/web/print/template/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog class="print_template_dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :height="'auto'" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dayinyewuleixing')" required>
            <yi_dictionary_select :max="1" :type="'PRINT_TEMPLATE_BUSINESS_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouzongxiang')" required>
            <el-select v-model="yt.editObj.vertical">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enable">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')">
            <el-input type="textarea" v-model="yt.editObj.desc"></el-input>
          </el-form-item>
        </el-form>
        <yi_print_template :jsonStr.sync="yt.editObj.templateContent" ref="yi_print_template"></yi_print_template>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button
            :loading="yt.editObj.loading"
            size="mini"
            @click="
              $refs.yi_print_template.save();
              yt.req('POST', '/web/print/template/create');
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 复制表单 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dayinyewuleixing')" required>
            <yi_dictionary_select :max="1" :type="'PRINT_TEMPLATE_BUSINESS_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouzongxiang')" required>
            <el-select v-model="yt.editObj.vertical">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enable">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')">
            <el-input type="textarea" v-model="yt.editObj.desc"></el-input>
          </el-form-item>
        </el-form>
        <yi_print_template :jsonStr.sync="yt.editObj.templateContent" ref="yi_print_template"></yi_print_template>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button
            :loading="yt.editObj.loading"
            size="mini"
            @click="
              $refs.yi_print_template.save();
              yt.req('POST', '/web/print/template/create');
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dayinyewuleixing')" required>
            <yi_dictionary_select :max="1" :type="'PRINT_TEMPLATE_BUSINESS_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouzongxiang')" required>
            <el-select v-model="yt.editObj.vertical">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enable">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('miaoshu')">
            <el-input type="textarea" v-model="yt.editObj.desc"></el-input>
          </el-form-item>
        </el-form>
        <yi_print_template :jsonStr.sync="yt.editObj.templateContent" ref="yi_print_template"></yi_print_template>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button
            :loading="yt.editObj.loading"
            size="mini"
            @click="
              $refs.yi_print_template.save();
              yt.req('POST', '/web/print/template/update', beforeNewAdd);
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_label_management_print_template_list',
  components: {
    // importExcel
  },
  data() {
    return {
      columns: [
        {
          label: 'dayinmobanmingcheng',
          prop: 'name'
        },
        {
          label: 'dayinyewuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'PRINT_TEMPLATE_BUSINESS_TYPE',
          width: 150
        },
        {
          label: 'shifouzongxiang',
          prop: 'vertical',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'shifouqiyong',
          prop: 'enable',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'miaoshu',
          prop: 'desc'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 150
        },

        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>
